import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

export default function AdminFab() {
  return (
    <Link
      to="/admin/login"
      data-testid="admin-fab"
      title="Login CPanel Admin"
      aria-label="Login Admin"
      className="fixed z-[60] bottom-5 left-5 md:bottom-7 md:left-7 w-11 h-11 md:w-12 md:h-12 rounded-full bg-neutral-900/80 hover:bg-px-red text-neutral-300 hover:text-white border border-neutral-700 backdrop-blur-sm shadow-lg flex items-center justify-center transition-all hover:scale-105 opacity-60 hover:opacity-100"
    >
      <Lock className="w-4 h-4 md:w-5 md:h-5" />
    </Link>
  );
}
